import { defaultFont } from 'src/theme/core/typography';

export const STORAGE_KEY = 'app-settings';
export const defaultSettings = {
  colorScheme: 'light',
  direction: 'ltr',
  contrast: 'default',
  navLayout: 'vertical',
  primaryColor: 'default',
  navColor: 'integrate',
  compactLayout: true,
  fontFamily: defaultFont,
  // Viewing/editing timezone (IANA). null = follow the browser timezone (spec §5).
  timezone: null,
};
